import { render, staticRenderFns } from "./MenuGroupList.vue?vue&type=template&id=2fbb476c"
import script from "./MenuGroupList.vue?vue&type=script&lang=ts"
export * from "./MenuGroupList.vue?vue&type=script&lang=ts"
import style0 from "./MenuGroupList.vue?vue&type=style&index=0&id=2fbb476c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports